import { ScrollCaptain } from 'scroll-captain';
import './topic-teaser.scss';
class TopicTeaser {
    constructor (element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-topicteaser',
            stickyItemValue: 'sticky-item',
            topicValue: 'topic',
            topicMediaValue: 'topic-media',
            topicContentValue: 'topic-content',
            breakpoint: 768
        };

        // Merge settings
        this.settings = Object.assign({}, defaults, options);

        // DOM Elements
        this.$root = element;
        this.$stickyItem = this.$root.querySelector(`[${this.settings.initAttr}="${this.settings.stickyItemValue}"]`);
        this.$$topics = this.$root.querySelectorAll(`[${this.settings.initAttr}="${this.settings.topicValue}"]`);

        // Options
        this.animation = [];
        this.breakpoint = window.matchMedia(`(min-width: ${this.settings.breakpoint}px)`);
        this.breakpointActive = this.breakpoint.matches;
    }

    initialize () {
        if (this.$stickyItem && this.$$topics.length > 0) {
            this.setStickySpacing();
            this.loadAnimation();
            this.setEvents();
        }
    }

    loadAnimation () {        
        this.$$topics.forEach(($topic, index) => {
            this.animation[index] = new ScrollCaptain($topic, {
                initAttr: this.settings.initAttr,
                animateContent: {
                    targetSuffix: this.settings.topicContentValue,
                    onscroll: true,
                    opacity: this.breakpoint.matches ? this.breakpoint.matches ? { 0: window.reducedMotionActive ? 1 : 0, 10: window.reducedMotionActive ? 1 : 0, 50: 1 } : null : null,
                    translateY: this.breakpoint.matches ? { 0: window.reducedMotionActive ? 0 : 1 * 50 * (index + 1), 50: 0 } : null
                },
                animateMedia: {
                    targetSuffix: this.settings.topicMediaValue,
                    onscroll: true,
                    scale: this.breakpoint.matches ? { 49: window.reducedMotionActive ? 1 : 0.97, 50: 1 } : null,
                    translateY: this.breakpoint.matches ? { 0: window.reducedMotionActive ? 0 : 1 * 30 * (index + 1), 50: 0 } : null
                },
                updateOnResize: () => {
                    if (this.breakpoint.matches !== this.breakpointActive) {
                        this.breakpointActive = this.breakpoint.matches;
                        this.updateAnimation(false);
                    }
                }
            });
        });
    }

    updateAnimation (updateRequired) {    
        this.$$topics.forEach(($topic, index) => {
            this.animation[index].defaultOptions.animateContent.opacity = this.breakpoint.matches ? this.breakpoint.matches ? { 0: window.reducedMotionActive ? 1 : 0, 10: window.reducedMotionActive ? 1 : 0, 50: 1 } : null : null;
            this.animation[index].defaultOptions.animateContent.translateY = this.breakpoint.matches ? { 0: window.reducedMotionActive ? 0 : 1 * 50 * (index + 1), 50: 0 } : null;
            this.animation[index].defaultOptions.animateMedia.translateY = this.breakpoint.matches ? { 0: window.reducedMotionActive ? 0 : 1 * 30 * (index + 1), 50: 0 } : null;
            this.animation[index].defaultOptions.animateMedia.scale = this.breakpoint.matches ? { 49: window.reducedMotionActive ? 1 : 0.97, 50: 1 } : null;

            if (updateRequired) {
                this.animation[index].update();
            }
        });
    }
    
    setStickySpacing () {
        if (this.breakpoint.matches) {
            const stickyItemHeight = this.$stickyItem.clientHeight - (parseFloat(getComputedStyle(this.$stickyItem).paddingTop) + parseFloat(getComputedStyle(this.$stickyItem).paddingBottom));
            const stickySpacing = (window.innerHeight - stickyItemHeight) * 0.5;
            this.$root.style.setProperty('--top', stickySpacing > 0 ? 0: 'auto');
            this.$root.style.setProperty('--padding-block', stickySpacing > 0 ? `${stickySpacing}px`: 0);
        }
    }

    setEvents () {
        window.resizeHandler.customFunctions.push(() => {
            this.setStickySpacing();
        });

        window.addEventListener('motionPreferenceChanged', () => {
            this.updateAnimation(true);
        });
    }
}

export { TopicTeaser };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-topicteaser="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new TopicTeaser($root);
            $rootAPI.initialize();
        });
    }
});
